export default __webpack_public_path__ + "8e50c7a.png";